import { Button, MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const ProducersList = ({ history }) => (
  <Main
    page={{
      name: "Producenci",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Producenci",
        },
      ],
      buttons: (
        <Button type="add" text="Dodaj producenta" path="/producers/new" />
      ),
    }}
  >
    <MainList
      query_key="producers"
      api_path="/producers"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/producers/${item.id}`)}
      renderItem={({
        id,
        name,
        allegro_responsible_producer_name,
        erli_responsible_producer_name,
        amazon_gpsr_manufacturer_email,
        brands
      }) => (
        <>
          <td>{id}</td>
          <td>{name}</td>
          <td>{allegro_responsible_producer_name}</td>
          <td>{erli_responsible_producer_name}</td>
          <td>{amazon_gpsr_manufacturer_email}</td>
          <td>{brands?.map(({name}) => name).join(', ')}</td>
        </>
      )}
    />
  </Main>
);

export default ProducersList;
